import * as React from 'react';

import { Box } from '../box';
import { ColorProp, usePaletteColor } from '../theme';
import { BaseProps, enumType, makeEnum, withVersion } from '../utils';

export const ColorIndicatorSize = makeEnum(10, 18, 24);
export type ColorIndicatorSize = enumType<typeof ColorIndicatorSize>;

const COLOR_INDICATOR_FILL: ColorProp = 'components.avatar.fill';

export interface ColorIndicatorProps extends BaseProps {
    color?: string;
    size?: ColorIndicatorSize;
}

const ColorIndicatorImpl = React.forwardRef<
    HTMLDivElement,
    ColorIndicatorProps
>((props, ref) => {
    const {
        color,
        size = 18,
        className,
        'data-role': dataRole = 'color-indicator',
        'data-role-value': dataRoleValue
    } = props;
    const fallbackColor = usePaletteColor(COLOR_INDICATOR_FILL);
    const resolvedColor = color || fallbackColor;

    return (
        <Box
            ref={ref}
            className={className}
            data-role={dataRole}
            data-role-value={dataRoleValue}
            borderColor="divider"
            sx={{
                width: size,
                height: size,
                minWidth: size,
                borderRadius: '50%',
                backgroundColor: resolvedColor,
                border: '1px solid'
            }}
        />
    );
});

(ColorIndicatorImpl as React.NamedExoticComponent).displayName =
    'ColorIndicator';

export const ColorIndicator = withVersion(ColorIndicatorImpl, '1.0.0');
